import apiHandler from "../core/apiHandler";

const employeeApi = apiHandler('employees');

export default employeeApi;